import { ScnMainData } from "../scn/app";

export function isValidEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export function getAgencyIdsFromDataContext(dataContext: ScnMainData | null): string[] {
  if (dataContext?.agency_id) {
    return [dataContext.agency_id];
  }
  if (dataContext?.agenciesOfRg4?.length) {
    return dataContext.agenciesOfRg4.map(agency => agency.agency_id);
  }
  // RG2 global view: agencies list with `id` field
  if (dataContext?.agencies?.length) {
    return dataContext.agencies.map(agency => agency.id);
  }
  return [];
}

export function formatFrenchPhoneDisplay(phone?: string | null): string {
  if (!phone) return ""
  // Garder uniquement chiffres et +
  let cleaned = phone.replace(/[^\d+]/g, "")
  // +33 / 0033 → 0…
  if (cleaned.startsWith("+33")) cleaned = "0" + cleaned.slice(3)
  else if (cleaned.startsWith("0033")) cleaned = "0" + cleaned.slice(4)
  // Si on a 9 chiffres après normalisation (ex: +33778882853 → 0778882853)
  // le "0" a déjà été ajouté ci-dessus
  // Cas "+3306…" → "006…" : corriger le double 0
  cleaned = cleaned.replace(/^00/, "0")
  const digits = cleaned.replace(/\D/g, "")
  if (digits.length !== 10) return phone // fallback si format inattendu
  return digits.replace(/(\d{2})(?=\d)/g, "$1 ").trim()
}